import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import ExpirationDate from '@square/dashboard-data/models/squareup/simple-instrument-store/api/expiration-date';
export default ProtoBaseModel.extend({
  pan: attr(String),
  expirationDate: attr(ExpirationDate),
  securityCode: attr(String),
  postalCode: attr(String)
});